// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const updateProjectCommitteeMutation = gql`
  mutation updateProjectCommittee(
    $committeeInfo: UpdateProjectCommitteeInput!
  ) {
    updateProjectCommittee(input: $committeeInfo) {
      code
      message
      success
      committee {
        id
        collaborationName
        name
        description
        category
        url
      }
    }
  }
`;
